export class Payment {
    amount: number;
    zone: string;
    booking_id: string;
    currency: string = 'VND';
}


// WEBPACK FOOTER //
// ./src/holiday/models/Payment.ts